module.exports = __webpack_public_path__ + "static/media/Illus-Bread_2.0bf6324a.png";